let loading;
export function loadReceiptVision() {
  if (!loading) loading = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = '/vendor/opencv/opencv-4.13.0.js';
    script.onload = () => {
      const cv=window.cv;
      const ready=()=>{if(!cv?.Mat){loading=undefined;reject(new Error('Scanner unavailable'));return;} delete cv.then;resolve(cv);};
      if(cv?.Mat) ready();
      else if(cv) {const previous=cv.onRuntimeInitialized;cv.onRuntimeInitialized=()=>{previous?.();ready();};}
      else {loading=undefined;reject(new Error('Scanner unavailable'));}
    };
    script.onerror = () => { loading = undefined; reject(new Error('Scanner could not load.')); };
    document.head.appendChild(script);
  });
  return loading;
}
export function orderCorners(points) {
  const sorted = [...points].sort((a,b) => a.y-b.y);
  const top = sorted.slice(0,2).sort((a,b)=>a.x-b.x), bottom = sorted.slice(2).sort((a,b)=>a.x-b.x);
  return [top[0],top[1],bottom[1],bottom[0]];
}
export function detectReceipt(cv, canvas) {
  const src=cv.imread(canvas), gray=new cv.Mat(), edges=new cv.Mat(), contours=new cv.MatVector(), hierarchy=new cv.Mat();
  let best=null,area=canvas.width*canvas.height*.12;
  try {
    cv.cvtColor(src,gray,cv.COLOR_RGBA2GRAY);cv.GaussianBlur(gray,gray,new cv.Size(5,5),0);cv.Canny(gray,edges,35,110);cv.findContours(edges,contours,hierarchy,cv.RETR_EXTERNAL,cv.CHAIN_APPROX_SIMPLE);
    for(let i=0;i<contours.size();i++) { const contour=contours.get(i),approx=new cv.Mat();try {
      cv.approxPolyDP(contour,approx,.025*cv.arcLength(contour,true),true);const candidateArea=Math.abs(cv.contourArea(approx));
      if(approx.rows===4 && cv.isContourConvex(approx) && candidateArea>area) { const p=[];for(let k=0;k<4;k++)p.push({x:approx.data32S[k*2],y:approx.data32S[k*2+1]});best=orderCorners(p);area=candidateArea; }
    } finally {contour.delete();approx.delete();} }
    return best;
  } finally {src.delete();gray.delete();edges.delete();contours.delete();hierarchy.delete();}
}
export function validCorners(corners) {
  if (!corners || corners.length !== 4) return false;
  const crosses=corners.map((p,i)=>{const q=corners[(i+1)%4],r=corners[(i+2)%4];return (q.x-p.x)*(r.y-q.y)-(q.y-p.y)*(r.x-q.x);});
  return crosses.every(v=>v>4)||crosses.every(v=>v< -4);
}
export function cropReceipt(cv, canvas, corners, mode='original') {
  if (!validCorners(corners)) throw new Error('Crop corners must form a convex rectangle.');
  const [a,b,c,d]=corners, distance=(p,q)=>Math.hypot(p.x-q.x,p.y-q.y);
  const width=Math.max(1,Math.round(Math.max(distance(a,b),distance(d,c)))),height=Math.max(1,Math.round(Math.max(distance(a,d),distance(b,c))));
  const src=cv.imread(canvas),dst=new cv.Mat(),from=cv.matFromArray(4,1,cv.CV_32FC2,corners.flatMap(p=>[p.x,p.y])),to=cv.matFromArray(4,1,cv.CV_32FC2,[0,0,width-1,0,width-1,height-1,0,height-1]),transform=cv.getPerspectiveTransform(from,to);
  try {
    cv.warpPerspective(src,dst,transform,new cv.Size(width,height),cv.INTER_LINEAR,cv.BORDER_REPLICATE);
    if(mode!=='original') {cv.cvtColor(dst,dst,cv.COLOR_RGBA2GRAY);if(mode==='enhanced')cv.equalizeHist(dst,dst);else cv.adaptiveThreshold(dst,dst,255,cv.ADAPTIVE_THRESH_GAUSSIAN_C,cv.THRESH_BINARY,31,12);}
    const result=document.createElement('canvas');result.width=width;result.height=height;cv.imshow(result,dst);return result;
  } finally {src.delete();dst.delete();from.delete();to.delete();transform.delete();}
}
